// src/components/visits/VisitsStats.jsx
import React from 'react';
import { Activity } from 'lucide-react';
import { useTheme } from '../../theme/ThemeContext';

const VisitsStats = ({ totalVisits }) => {
  const { theme } = useTheme();

  return (
    <section className="mb-4 grid gap-4 md:grid-cols-3">
      <div
        className={`flex items-center justify-between rounded-xl border border-slate-200 bg-white/80 px-4 py-3 shadow-sm dark:border-slate-700 dark:bg-slate-900/80 ${
          theme.card
        }`}
      >
        <div>
          <p className="text-xs font-medium uppercase tracking-wide text-slate-500 dark:text-slate-400">
            Total Visits
          </p>
          <p className="mt-1 text-2xl font-semibold text-slate-900 dark:text-slate-50">
            {totalVisits}
          </p>
        </div>
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-sky-500/10 text-sky-500">
          <Activity className="h-5 w-5" />
        </div>
      </div>

      {/* Empty slots for future stats */}
      <div className="hidden md:block rounded-xl border border-dashed border-slate-200/80 bg-slate-50/60 dark:border-slate-700/70 dark:bg-slate-900/40" />
      <div className="hidden md:block rounded-xl border border-dashed border-slate-200/80 bg-slate-50/60 dark:border-slate-700/70 dark:bg-slate-900/40" />
    </section>
  );
};

export default VisitsStats;
